import React, { useState, useEffect } from "react";
import "./uploader.less";
import { message, Upload } from "antd";
import "./iconfont.js";
import "./mutipleUploader.less";
import OssUtils from "../util/oss-utils";

/**
 * @param {allowTypes[]} 允许的图片类型，数组。默认不限制                  可选
 * @param {onChange} 图片改变回调                                       可选
 * @param {multiple} 是否支持多选                                      可选
 * @param {maxCount} 最大上传个数                                       可选
 * @param {uploadPrefix} 上传文件的前缀路径                              可选
 */

function MultipleUploader({
    multiple = false,
    maxCount = 1,
    unique = false,
    value,
    allowTypes = [],
    disabled = false,
    onChange = function () {},
    uploadPrefix = "",
}) {
    useEffect(() => {
        value instanceof Array && setFileList(value);
    }, [value]);
    let [fileList, setFileList] = useState([]);
    function uploadChange({ fileList }) {
        if (fileList.length > maxCount) {
            fileList = fileList.slice(0, maxCount);
        }
        onChange(fileList);
    }
    function onRemove(file) {
        fileList = fileList.filter(v => v.url !== file.url);
        onChange(fileList);
    }
    function beforeUpload(file) {
        const suffix = file.name.slice(file.name.lastIndexOf(".")).toLocaleLowerCase();
        const fileName = file.name.slice(0, file.name.lastIndexOf("."));
        if (allowTypes.length > 0 && !allowTypes.includes(suffix)) {
            message.error(`对不起，只支持类型为${allowTypes}的文件`);
            return Upload.LIST_IGNORE;
        }

        return new Promise(async (resolve, reject) => {
            try {
                // 生成key，支持前缀
                const key = OssUtils.generateOssKeyWithNumber(file.name, uploadPrefix);

                // 获取OSS签名
                const signatureData = await OssUtils.getOssSignature({
                    bucket: "dante-img",
                    region: "cn-hangzhou",
                    maxFileSize: file.size || 10485760, // 10MB
                    uploadDir: key,
                });

                const uploadUrl = OssUtils.processUploadUrl(signatureData.host);

                // 为文件对象添加签名信息
                OssUtils.attachSignatureToFile(file, signatureData, key, uploadUrl);

                if (unique) {
                    file.unique = fileName + file.url;
                }

                resolve(file);
            } catch (error) {
                message.error("获取上传签名失败，请重试");
                console.error("Get signature error:", error);
                reject(error);
            }
        });
    }
    function getExtraData(file) {
        return {
            key: file.key,
            success_action_status: 200,
            policy: file.policy,
            "x-oss-signature": file.signature,
            "x-oss-signature-version": file.version,
            "x-oss-credential": file.xOssCredential,
            "x-oss-date": file.xOssDate,
            "x-oss-security-token": file.securityToken,
        };
    }
    const props = {
        name: "file",
        fileList,
        action: file => file.uploadUrl || "https://dante-img.oss-cn-hangzhou.aliyuncs.com/",
        onChange: uploadChange,
        onRemove,
        data: getExtraData,
        beforeUpload,
        listType: "picture-card",
        multiple,
        maxCount,
        accept: allowTypes,
        disabled,
    };
    return <Upload {...props}>{fileList.length < maxCount && "+ 上传"}</Upload>;
}

export default MultipleUploader;
